import $ from 'jquery';
import imagesLoaded from 'imagesloaded';

imagesLoaded.makeJQueryPlugin($);

const allImageParents = $('.text-image-button-block__image-section');

const setImageWidth = () => {
    const bodyWidth = $('body').outerWidth();
    $('.text-image-button-block').css({
        width: bodyWidth,
        marginLeft: `calc(${-bodyWidth / 2}px + 50%)`,
    });

    for (let i = 0; i < allImageParents.length; i++) {
        const current = allImageParents.eq(i);

        if (window.matchMedia('(min-width: 992px)').matches) {
            current.css('width', bodyWidth / 2 - 95);
        } else {
            current.css('width', '');
        }
    }
};

$(window).bind('resize', setImageWidth).trigger('resize');
